import script from "./team.vue?vue&type=script&setup=true&lang=ts"
export * from "./team.vue?vue&type=script&setup=true&lang=ts"

import "./team.vue?vue&type=style&index=0&id=1c7a04d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c7a04d8"]])

export default __exports__